import * as Popover from "@radix-ui/react-popover";
import { useState } from "react";
import { Button } from "react-migration/components/Button";
import { Site } from "react-migration/domains/sites/typings/Site";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { getMapSiteSelectionLocation } from "react-migration/lib/util/getMapSiteSelectionLocation";
import { router } from "src/js/router/react-router";
import { mapStore } from "src/js/stores/map/store";
import { geoJsonPolyToGoogleBounds } from "src/js/util/map_util";
import { useSnapshot } from "valtio";

export const SavedSiteButton = ({ site }: { site: Site }) => {
  const { t } = useTranslation();
  const { googleMap } = useSnapshot(mapStore);
  const [showSavedPopover, setShowSavedPopover] = useState(false);
  const stage = site?._stage;

  return (
    <Popover.Root open={showSavedPopover} onOpenChange={setShowSavedPopover}>
      <Popover.Anchor>
        <Button variant="secondary" onClick={() => setShowSavedPopover(true)}>
          {t("sites.save_site.save_site_dropdown.saved")}
        </Button>
      </Popover.Anchor>

      <Popover.Portal>
        <Popover.Content
          className="z-30 flex flex-col p-4 bg-white border rounded-sm md:w-60 gap-y-4 border-neutral-100 drop-shadow-xl"
          align="center"
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          {stage?.name && (
            <div className="flex items-center gap-2">
              <div className="h-3 w-3 rounded" style={{ backgroundColor: stage.color || "gray" }} />
              {stage.name}
            </div>
          )}
          <div className="flex flex-col gap-2">
            <Button
              leadIcon="lt-kanban-line"
              onClick={() => {
                router.push({ name: "sites", query: { site_id: site?._id } });
              }}
            >
              {t("sidebar.site.view_in_pipeline")}
            </Button>
            <Button
              leadIcon="lt-map-2-line"
              onClick={() => {
                if (site.geometry && window.location.pathname.startsWith("/map")) {
                  googleMap?.fitBounds(geoJsonPolyToGoogleBounds(site.geometry));
                } else {
                  router.push(
                    getMapSiteSelectionLocation({
                      geometry: site.geometry,
                      siteLatLng: {
                        lat: site.location?.coordinates[1] ?? 0,
                        lng: site.location?.coordinates[0] ?? 0,
                      },
                      siteId: site._id,
                    })
                  );
                }
              }}
            >
              {t("sidebar.site.view_map")}
            </Button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
